import { AxiosError, AxiosInstance } from 'axios'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'
import { captureExceptionWithMessage } from 'utils/logRocket'

const logErrorHandler = (error: AxiosError) => {
  captureExceptionWithMessage('Contacts API Error', error, {
    url: window.location.href,
    endpoint: error.config.url,
    errorData: JSON.stringify(error.config)
  })
}

const responseErrorHandlers = [logErrorHandler]

export const ContactsApi: AxiosInstance = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.CONTACTS_API
  }
})
export const getGeoIPProperties = async (endUserId: string) => {
  return ContactsApi.get(`/end_user/${endUserId}/properties/geoip`)
}

export const getDriftIntel = async (endUserId: string, targets: number[]) => {
  return ContactsApi.post('/derivation', { endUserId, targets })
}
